import { useState } from "react";
import OptimizedImage from "../../common/OptimizedImage/OptimizedImage";
import "./MarqueeLogos.css";

export default function MarqueeLogos({ logos = [], speed = 25 }) {
  const duration = Math.max(8, Math.min(60, speed));
  const [ready, setReady] = useState(false);
  const onLastImageDone = () => setReady(true);

  return (
    <div className="client-logos-marquee" aria-label="Client logos marquee">
      <div
        className={`client-logos-marquee-track ${ready ? "animate" : "preparing"}`}
        style={{ ["--marquee-duration"]: `${duration}s` }}
      >
        <div className="marquee-group">
          {logos.map((logo, i) => (
            <div className="marquee-logo" key={i}>
              <OptimizedImage
                src={logo.src}
                alt={logo.alt}
                className="client-logo-img"
                decoding="async"
                loading="eager"
                onLoad={i === logos.length - 1 ? onLastImageDone : undefined}
                onError={i === logos.length - 1 ? onLastImageDone : undefined}
              />
            </div>
          ))}
        </div>

        <div className="marquee-group" aria-hidden="true">
          {logos.map((logo, i) => (
            <div className="marquee-logo" key={`dup-${i}`} aria-hidden="true">
              <OptimizedImage
                src={logo.src}
                alt={logo.alt}
                className="client-logo-img"
                decoding="async"
                loading="eager"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}